// Central helpers for reading/writing selected tenantId for superadmin override

const KEY = 'sa_tenant_id';

export function getTenantId(): number | null {
  const raw = localStorage.getItem(KEY);
  if (!raw) return null;
  const n = Number(raw);
  return Number.isFinite(n) && n > 0 ? n : null;
}

export function setTenantId(id: number | null) {
  if (id && id > 0) localStorage.setItem(KEY, String(id));
  else localStorage.removeItem(KEY);
}


